import { Pipe, PipeTransform } from '@angular/core';
import { commaFormat } from '@mbp/core';

@Pipe({
  name: 'coverageDisplay',
})
export class CoverageDisplayPipe implements PipeTransform {
  transform(coverageDisplayTypeID: number, coverageMonths: number, coverageMiles: number): string {
    let display = '';

    if (coverageDisplayTypeID === 1) {
      // Months
      display += coverageMonths > 0 ? coverageMonths.toString() + ' month' + (coverageMonths > 1 ? 's' : '') : 'Unlimited';
    } else {
      // Years
      let years = coverageMonths / 12;
      display += years.toString() + ' year' + (years > 1 ? 's' : '');
    }

    if (coverageMiles < 999999) {
      display += ' / ' + (coverageMiles != null && coverageMiles > 0 ? commaFormat.format(coverageMiles) : '0') + ' miles';
    }

    return display;
  }
}
